import { useSelector } from 'react-redux';
import { ExternalLink } from '@components/Link';
import { useLocations, useTranslation } from '@hooks';
import { getPaymentDetailRows } from './paymentDetailRows';
import { PaymentDetailsList } from './styles';

const PaymentDetails = ({ data }) => {
    const { t } = useTranslation();
    const language = useSelector(state => state.auth.user?.language);
    const { locationsMap } = useLocations();
    const { rows, receiptUrl } = getPaymentDetailRows(data, { t, language, locationsMap });

    return (
        <div>
            <PaymentDetailsList>
                {rows.map(row => (
                    <div key={row.key}>
                        <dt>{row.label}</dt>
                        <dd>{row.value}</dd>
                    </div>
                ))}
            </PaymentDetailsList>
            {receiptUrl && (
                <ExternalLink href={receiptUrl} color="inherit">
                    {t('ContactsPage.paymentDetails.viewReceipt')}
                </ExternalLink>
            )}
        </div>
    );
};

export default PaymentDetails;
